export const MapPoint = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.4499 20.8305L6.63197 12.9466C3.86939 8.42605 7.12282 2.625 12.4207 2.625C17.7186 2.625 20.972 8.42605 18.2095 12.9466L13.3915 20.8305C12.9479 21.5565 11.8935 21.5565 11.4499 20.8305Z'
        stroke='currentColor'
        strokeWidth='1.25'
      />
      <circle
        cx='12.4233'
        cy='9.20451'
        r='2.97795'
        stroke='currentColor'
        strokeWidth='1.25'
      />
    </svg>
  )
}
